import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { OFFERSATFIRSTREQUEST, OFFERSPERREQUEST } from "./config";
import { boardTypes, getHost, offerSortOptions, populatePost } from "./utils";
import { setAgencyPictures } from "./cacheSlice";
import { setHotelCount } from "./filterSlice";

axios.defaults.headers.common["AgencyID"] = window.configData.AGENCYID;
axios.defaults.headers.common["Version"] = import.meta.env.VITE_APP_VERSION;
axios.defaults.headers.common["App"] = window.configData.APP;

function getRootDomain() {
  const host = window.location.hostname;
  const parts = host.split(".");

  if (parts.length <= 2) {
    return host;
  }

  return parts.slice(-2).join(".");
}

export const checkActions = createAsyncThunk("offers/checkActions", async (payload, thunkAPI) => {
  const state = thunkAPI.getState();

  try {
    const response = await axios.post(getHost() + "/checkActions", {
      promosession: state.system.sessionId,
      offer: payload.offer,
      queryid: state.offers.offerqueryid,
      agencypictures: payload.agencypictures,
      couponcode: state.search.couponcode,
    });
    thunkAPI.dispatch(
      setAgencyPictures({
        HotelGiataID: payload.offer.hotel.HotelCodes.HotelGiataID,
        pictures: Array.isArray(response.data.agencypictures) ? [...response.data.agencypictures] : [],
      }),
    );
    delete response.data.agencypictures;
    return response.data;
  } catch (error) {
    return thunkAPI.rejectWithValue({ error: error.message });
  }
});

export const checkActionsRecommended = createAsyncThunk("offers/checkActionsRecommended", async (payload, thunkAPI) => {
  const state = thunkAPI.getState();

  try {
    const response = await axios.post(getHost() + "/checkActions", {
      promosession: state.system.sessionId,
      offer: payload.offer,
      queryid: state.offers.offerqueryid,
      agencypictures: payload.agencypictures,
      couponcode: state.search.couponcode,
    });
    thunkAPI.dispatch(
      setAgencyPictures({
        HotelGiataID: payload.offer.hotel.HotelCodes.HotelGiataID,
        pictures: Array.isArray(response.data.agencypictures) ? [...response.data.agencypictures] : [],
      }),
    );
    delete response.data.agencypictures;
    return response.data;
  } catch (error) {
    return thunkAPI.rejectWithValue({ error: error.message });
  }
});

export const checkActionsDesired = createAsyncThunk("offers/checkActionsDesired", async (payload, thunkAPI) => {
  const state = thunkAPI.getState();

  try {
    const response = await axios.post(getHost() + "/checkActions", {
      promosession: state.system.sessionId,
      offer: payload.offer,
      queryid: state.offers.offerqueryid,
      agencypictures: payload.agencypictures,
      couponcode: state.search.couponcode,
    });
    thunkAPI.dispatch(
      setAgencyPictures({
        HotelGiataID: payload.offer.hotel.HotelCodes.HotelGiataID,
        pictures: Array.isArray(response.data.agencypictures) ? [...response.data.agencypictures] : [],
      }),
    );
    delete response.data.agencypictures;
    return response.data;
  } catch (error) {
    return thunkAPI.rejectWithValue({ error: error.message });
  }
});

export const sendQuery = createAsyncThunk("offers/sendQuery", async (payload, thunkAPI) => {
  const state = thunkAPI.getState();

  try {
    const response = await axios.post(getHost() + "/sendQuery", {
      promosession: state.system.sessionId,
      searchOptions: { ...state.search },
      sortOrder: state.search.sorting.sorting,
      mode: state.system.mode,
      queryid: state.search.queryid,
      couponcode: state.search.couponcode,
      //travellers: state.search.travellers,
    });

    return response.data;
  } catch (error) {
    return thunkAPI.rejectWithValue({ error: error.message });
  }
});

export const searchOffers = createAsyncThunk("offers/searchOffers", async (payload, thunkAPI) => {
  const state = thunkAPI.getState();
  //console.log(JSON.stringify(state.search));
  let url = !window.tileView ? "/bestPackageOfferForHotel" : "/bestPackageOfferForRegion";
  if (state.search.activeMode == "ACC") {
    url = !window.tileView ? "/bestAccommodationOfferForHotel" : "/bestAccommodationOfferForRegion";
  }
  const rootDomain = getRootDomain();
  if (window.setCookie) {
    window.setCookie("lastsearch", state.search.queryid, {
      expires: new Date(2099, 1, 1),
      path: "/",
      domain: `.${rootDomain}`,
      secure: true,
      sameSite: "none",
    });
  }

  try {
    const response = await axios.post(getHost() + url, {
      ...populatePost(
        state.search.selectedDestination,
        {
          ...state.search,

          promosession: state.system.sessionId,
          offset: payload.offset,
          amount: payload.offset > 0 ? OFFERSPERREQUEST : OFFERSATFIRSTREQUEST,
        },
        state.properties.departureStations,
      ),

      sortOrder: state.search.sorting.sorting,
      mode: state.system.mode,
      couponcode: state.search.couponcode,

      //travellers: state.search.travellers,
    });

    if (response.data.Offers.OfferCount > 0) {
      response.data.Offers.Offer = response.data.Offers.Offer.map((e) => {
        return {
          ...e,
          adults: state.search.adults.value,
          children: state.search.children.value,
          //duration: state.search.duration.label,
          //stations: state.search.stations,
          //travelDate: state.search.travelDate.from,
          //destination: [...state.search.selectedDestination],
          //displaydestination: [...state.search.selectedDestination],
        };
      });
      response.data.Offers.Offer = response.data.Offers.Offer.map((e) => {
        return !e.OfferServices.Package
          ? {
              ...e,
              OfferServices: {
                Package: { Accommodation: e.OfferServices.Accommodation },
              },
            }
          : e;
      });
      for (let i = 0; i < response.data.Offers.Offer.length; i++) {
        let offer = response.data.Offers.Offer[i];
        if (offer?.OfferServices?.Package?.Accommodation?.BoardType) {
          let bt = boardTypes.find((e) => e.searchKeys.includes(offer.OfferServices.Package.Accommodation.BoardType));
          if (bt) {
            offer.OfferServices.Package.Accommodation.BoardType = bt.value;
          }
        }
      }
    }

    if (Array.isArray(response.data.Offers.Offer)) {
      if (state.search.durationkind && state.search.durationkind.value === "Stay") {
        let dur = state.search.duration.value;

        if (dur === "0.1") {
          let differenceInTime = new Date(state.search.travelDate.to.split('"').join("")).getTime() - new Date(state.search.travelDate.from.split('"').join("")).getTime();

          dur = Math.floor(differenceInTime / (1000 * 3600 * 24)) + "";
          if (state.search.durationkind.value === "Stay") dur = Math.floor(differenceInTime / (1000 * 3600 * 24)) + "";
        }

        if ((dur + "").indexOf("-") > -1) {
          let durmin = dur.split("-")[0] * 1;
          let durmax = dur.split("-")[1] * 1;
          response.data.Offers.Offer = response.data.Offers.Offer.filter((e) => e.TravelDateInfo && e.TravelDateInfo.OvernightStays >= durmin && e.TravelDateInfo.OvernightStays <= durmax);
        } else {
          dur = dur * 1;
          response.data.Offers.Offer = response.data.Offers.Offer.filter((e) => e.TravelDateInfo && e.TravelDateInfo.OvernightStays === dur);
        }
      }

      //response.data.Offers.OfferCount = response.data.Offers.Offer.length;
    }
    //console.log(response.data);
    response.data.search = { ...state.search };

    if (response.data.total != null && payload.offset == 0) {
      thunkAPI.dispatch(setHotelCount(response.data.total));
    }

    return response.data;
  } catch (error) {
    return thunkAPI.rejectWithValue({ error: error.message });
  }
});

export const searchRecommendedHotels = createAsyncThunk("offers/searchRecommendedHotels", async (payload, thunkAPI) => {
  const state = thunkAPI.getState();
  //console.log(JSON.stringify(state.search));
  let url = !window.tileView ? "/bestPackageOfferForHotel" : "/bestPackageOfferForRegion";
  if (state.search.activeMode == "ACC") {
    url = !window.tileView ? "/bestAccommodationOfferForHotel" : "/bestAccommodationOfferForRegion";
  }

  try {
    const response = await axios.post(getHost() + url, {
      ...populatePost(
        state.search.selectedDestination,
        {
          ...state.search,

          promosession: state.system.sessionId,
          offset: 0,
          amount: 50,
        },
        state.properties.departureStations,
      ),
      HotelGiataID: state.offers.recommendedHotels.map((e) => e.id),
      sortOrder: state.search.sorting.sorting,
      mode: state.system.mode,
      couponcode: state.search.couponcode,

      //travellers: state.search.travellers,
    });

    if (response.data.Offers.OfferCount > 0) {
      response.data.Offers.Offer = response.data.Offers.Offer.map((e) => {
        return {
          ...e,
          adults: state.search.adults.value,
          children: state.search.children.value,
          //duration: state.search.duration.label,
          //stations: state.search.stations,
          //travelDate: state.search.travelDate.from,
          //destination: [...state.search.selectedDestination],
          //displaydestination: [...state.search.selectedDestination],
        };
      });
      response.data.Offers.Offer = response.data.Offers.Offer.map((e) => {
        return !e.OfferServices.Package
          ? {
              ...e,
              OfferServices: {
                Package: { Accommodation: e.OfferServices.Accommodation },
              },
            }
          : e;
      });
      for (let i = 0; i < response.data.Offers.Offer.length; i++) {
        let offer = response.data.Offers.Offer[i];
        if (offer?.OfferServices?.Package?.Accommodation?.BoardType) {
          let bt = boardTypes.find((e) => e.searchKeys.includes(offer.OfferServices.Package.Accommodation.BoardType));
          if (bt) {
            offer.OfferServices.Package.Accommodation.BoardType = bt.value;
          }
        }
      }
    }

    if (Array.isArray(response.data.Offers.Offer)) {
      if (state.search.durationkind && state.search.durationkind.value === "Stay") {
        let dur = state.search.duration.value;

        if (dur === "0.1") {
          let differenceInTime = new Date(state.search.travelDate.to.split('"').join("")).getTime() - new Date(state.search.travelDate.from.split('"').join("")).getTime();

          dur = Math.floor(differenceInTime / (1000 * 3600 * 24)) + "";
          if (state.search.durationkind.value === "Stay") dur = Math.floor(differenceInTime / (1000 * 3600 * 24)) + "";
        }

        if ((dur + "").indexOf("-") > -1) {
          let durmin = dur.split("-")[0] * 1;
          let durmax = dur.split("-")[1] * 1;
          response.data.Offers.Offer = response.data.Offers.Offer.filter((e) => e.TravelDateInfo && e.TravelDateInfo.OvernightStays >= durmin && e.TravelDateInfo.OvernightStays <= durmax);
        } else {
          dur = dur * 1;
          response.data.Offers.Offer = response.data.Offers.Offer.filter((e) => e.TravelDateInfo && e.TravelDateInfo.OvernightStays === dur);
        }
      }

      //response.data.Offers.OfferCount = response.data.Offers.Offer.length;
    }
    //console.log(response.data);
    response.data.search = { ...state.search };
    return response.data;
  } catch (error) {
    return thunkAPI.rejectWithValue({ error: error.message });
  }
});

export const searchDesiredHotels = createAsyncThunk("offers/searchDesiredHotels", async (payload, thunkAPI) => {
  const state = thunkAPI.getState();
  //console.log(JSON.stringify(state.search));
  let url = !window.tileView ? "/bestPackageOfferForHotel" : "/bestPackageOfferForRegion";
  if (state.search.activeMode == "ACC") {
    url = !window.tileView ? "/bestAccommodationOfferForHotel" : "/bestAccommodationOfferForRegion";
  }

  try {
    const response = await axios.post(getHost() + url, {
      ...populatePost(
        state.search.selectedDestination,
        {
          ...state.search,

          promosession: state.system.sessionId,
          offset: 0,
          amount: 50,
        },
        state.properties.departureStations,
      ),

      // Interne IBE-HotelIDs (normale UI-Suche) vs. giata (KIsha) in getrennte
      // Felder: HotelID = interne ID, HotelGiataID = giata. KIsha-Eintraege
      // tragen HotelGiataID -> landen NICHT als (ungueltige) HotelID im Backend.
      HotelID: state.search.desiredHotels.filter((e) => !e.HotelGiataID).map((e) => e.HotelID).filter(Boolean),
      ...(state.search.desiredHotels.some((e) => e.HotelGiataID)
        ? { HotelGiataID: state.search.desiredHotels.filter((e) => e.HotelGiataID).map((e) => e.HotelGiataID) }
        : {}),
      sortOrder: state.search.sorting.sorting,
      mode: state.system.mode,
      couponcode: state.search.couponcode,

      //travellers: state.search.travellers,
    });

    if (response.data.Offers.OfferCount > 0) {
      response.data.Offers.Offer = response.data.Offers.Offer.map((e) => {
        return {
          ...e,
          adults: state.search.adults.value,
          children: state.search.children.value,
          //duration: state.search.duration.label,
          //stations: state.search.stations,
          //travelDate: state.search.travelDate.from,
          //destination: [...state.search.selectedDestination],
          //displaydestination: [...state.search.selectedDestination],
        };
      });
      response.data.Offers.Offer = response.data.Offers.Offer.map((e) => {
        return !e.OfferServices.Package
          ? {
              ...e,
              OfferServices: {
                Package: { Accommodation: e.OfferServices.Accommodation },
              },
            }
          : e;
      });
      for (let i = 0; i < response.data.Offers.Offer.length; i++) {
        let offer = response.data.Offers.Offer[i];
        if (offer?.OfferServices?.Package?.Accommodation?.BoardType) {
          let bt = boardTypes.find((e) => e.searchKeys.includes(offer.OfferServices.Package.Accommodation.BoardType));
          if (bt) {
            offer.OfferServices.Package.Accommodation.BoardType = bt.value;
          }
        }
      }
    }

    if (Array.isArray(response.data.Offers.Offer)) {
      if (state.search.durationkind && state.search.durationkind.value === "Stay") {
        let dur = state.search.duration.value;

        if (dur === "0.1") {
          let differenceInTime = new Date(state.search.travelDate.to.split('"').join("")).getTime() - new Date(state.search.travelDate.from.split('"').join("")).getTime();

          dur = Math.floor(differenceInTime / (1000 * 3600 * 24)) + "";
          if (state.search.durationkind.value === "Stay") dur = Math.floor(differenceInTime / (1000 * 3600 * 24)) + "";
        }

        if ((dur + "").indexOf("-") > -1) {
          let durmin = dur.split("-")[0] * 1;
          let durmax = dur.split("-")[1] * 1;
          response.data.Offers.Offer = response.data.Offers.Offer.filter((e) => e.TravelDateInfo && e.TravelDateInfo.OvernightStays >= durmin && e.TravelDateInfo.OvernightStays <= durmax);
        } else {
          dur = dur * 1;
          response.data.Offers.Offer = response.data.Offers.Offer.filter((e) => e.TravelDateInfo && e.TravelDateInfo.OvernightStays === dur);
        }
      }

      //response.data.Offers.OfferCount = response.data.Offers.Offer.length;
    }
    //console.log(response.data);
    response.data.search = { ...state.search };
    return response.data;
  } catch (error) {
    return thunkAPI.rejectWithValue({ error: error.message });
  }
});

export const availabilityAndPriceCheckOffer = createAsyncThunk("offers/availabilityAndPriceCheckOffer", async (payload, thunkAPI) => {
  const state = thunkAPI.getState();

  try {
    const response = await axios.post(getHost() + "/availabilityAndPriceCheck", {
      offer: payload.offer?.origOffer,
      OfferID: payload.OfferID,
      flight: state.search.activeMode == "PAC" ? "1" : "0",
      adults: state.search.adults.value,
      children: state.search.children.value,
      childrenages: state.search.childrenages.map((e) => e.value).toString(),
      multiroomdivider: state.search.multiroomdivider,
    });

    return response.data;
  } catch (error) {
    console.log(error);

    return thunkAPI.rejectWithValue({ error: error.message });
  }
});

export const availabilityAndPriceCheckDesired = createAsyncThunk("offers/availabilityAndPriceCheckDesired", async (payload, thunkAPI) => {
  const state = thunkAPI.getState();

  try {
    const response = await axios.post(getHost() + "/availabilityAndPriceCheck", {
      offer: payload.offer?.origOffer,
      OfferID: payload.OfferID,
      flight: state.search.activeMode == "PAC" ? "1" : "0",
      adults: state.search.adults.value,
      children: state.search.children.value,
      childrenages: state.search.childrenages.map((e) => e.value).toString(),
      multiroomdivider: state.search.multiroomdivider,
    });

    return response.data;
  } catch (error) {
    console.log(error);

    return thunkAPI.rejectWithValue({ error: error.message });
  }
});

export const availabilityAndPriceCheckRecommended = createAsyncThunk("offers/availabilityAndPriceCheckRecommended", async (payload, thunkAPI) => {
  const state = thunkAPI.getState();

  try {
    const response = await axios.post(getHost() + "/availabilityAndPriceCheck", {
      offer: payload.offer?.origOffer,
      OfferID: payload.OfferID,
      flight: state.search.activeMode == "PAC" ? "1" : "0",
      adults: state.search.adults.value,
      children: state.search.children.value,
      childrenages: state.search.childrenages.map((e) => e.value).toString(),
      multiroomdivider: state.search.multiroomdivider,
    });

    return response.data;
  } catch (error) {
    console.log(error);

    return thunkAPI.rejectWithValue({ error: error.message });
  }
});

const initialState = {
  offerqueryid: "",
  offerInfos: {},
  recommendedInfos: {},
  desiredInfos: {},
  offersSearched: false,
  searchParams: {},
  queryorder: [],
  offerstopper: [],
  alternativeRegionName: "",
  specialAmount: [],
  specialRoomTypes: [],
  responseInfo: {},
  memo: [],
  additionals: {},
  banners: [],
  recommendedHotels: [],
  regioninfos: [],
  offerPage: 1,
  selectedOfferId: "",
  offerSort: offerSortOptions[1],
};

export const offersSlice = createSlice({
  name: "offers",
  initialState,
  reducers: {
    setOfferInfos: (state, action) => {
      state.offerInfos = action.payload;
    },

    setAlternativeRegionName: (state, action) => {
      state.alternativeRegionName = action.payload;
    },
    setRecommendedInfos: (state, action) => {
      state.recommendedInfos = action.payload;
    },
    setDesiredInfos: (state, action) => {
      state.desiredInfos = action.payload;
    },
    setBanners: (state, action) => {
      state.banners = Array.isArray(action.payload) ? action.payload : [];
    },
    setAdditionals: (state, action) => {
      state.additionals = Array.isArray(action.payload) ? action.payload : [];
    },
    setRecommendedHotels: (state, action) => {
      state.recommendedHotels = Array.isArray(action.payload) ? action.payload : [];
    },

    setRegioninfos: (state, action) => {
      state.regioninfos = Array.isArray(action.payload) ? action.payload : [];
    },
    setOfferqueryid: (state, action) => {
      state.offerqueryid = action.payload;
    },
    setOffersSearched: (state, action) => {
      state.offersSearched = action.payload;
    },
    setOfferPage: (state, action) => {
      state.offerPage = action.payload;
    },
    setOfferSort: (state, action) => {
      state.offerSort = action.payload;
    },
    setSpecialRoomTypes: (state, action) => {
      state.specialRoomTypes = action.payload;
    },

    setSelectedOfferId: (state, action) => {
      state.selectedOfferId = action.payload;
    },

    setMemo: (state, action) => {
      state.memo = action.payload;
    },
    addToMemo: (state, action) => {
      // Add - check if not already exists
      const exists = state.memo.some((item) => item.offer_id === action.payload.offer_id);
      if (!exists) {
        state.memo = [action.payload, ...state.memo];
      }
    },
    removeFromMemo: (state, action) => {
      // Remove by offer_id
      state.memo = state.memo.filter((item) => item.offer_id !== action.payload);
    },

    setMarked: (state, action) => {
      let infos = { ...state.offerInfos };

      for (let i = 0; i < infos.Offers.Offer.length; i++) {
        //console.log(infos.Offers.Offer[i]);
        if (infos.Offers.Offer[i].OfferID === action.payload.offerId) {
          // console.log(infos.Offers.Offer[i].OfferID);
          if (Array.isArray(infos.Offers.Offer[i].MarketingActions) && infos.Offers.Offer[i].MarketingActions.length > 0) {
            infos.Offers.Offer[i].MarketingActions[0].marked = action.payload.marked;
          } else {
            infos.Offers.Offer[i].MarketingActions = [
              {
                marked: action.payload.marked,
              },
            ];
          }
        }
      }

      state.offerInfos = { ...infos };
    },
  },
  extraReducers: (builder) => {
    builder.addCase(availabilityAndPriceCheckOffer.fulfilled, (state, action) => {
      let d = action.payload["ns2:AvailabilityAndPriceCheckRS"];

      let tmp;
      tmp = { ...state.offerInfos };

      //console.log(Array.isArray(tmp?.Offers?.Offer),d.Offer);
      if (Array.isArray(tmp?.Offers?.Offer) && d.Offer) {
        let tmpArray = tmp.Offers.Offer.map((element) => {
          return element.OfferID === action.meta.arg.OfferID ? { ...element, bookinginfo: d } : element;
        });
        tmp.Offers.Offer = tmpArray;
      }

      state.offerInfos = tmp;
    });
    builder.addCase(availabilityAndPriceCheckDesired.fulfilled, (state, action) => {
      let d = action.payload["ns2:AvailabilityAndPriceCheckRS"];

      let tmp;
      tmp = { ...state.desiredInfos };

      //console.log(Array.isArray(tmp?.Offers?.Offer),d.Offer);
      if (Array.isArray(tmp?.Offers?.Offer) && d.Offer) {
        let tmpArray = tmp.Offers.Offer.map((element) => {
          return element.OfferID === action.meta.arg.OfferID ? { ...element, bookinginfo: d } : element;
        });
        tmp.Offers.Offer = tmpArray;
      }

      state.desiredInfos = tmp;
    });
    builder.addCase(availabilityAndPriceCheckRecommended.fulfilled, (state, action) => {
      let d = action.payload["ns2:AvailabilityAndPriceCheckRS"];

      let tmp;
      tmp = { ...state.recommendedInfos };

      //console.log(Array.isArray(tmp?.Offers?.Offer),d.Offer);
      if (Array.isArray(tmp?.Offers?.Offer) && d.Offer) {
        let tmpArray = tmp.Offers.Offer.map((element) => {
          return element.OfferID === action.meta.arg.OfferID ? { ...element, bookinginfo: d } : element;
        });
        tmp.Offers.Offer = tmpArray;
      }

      state.recommendedInfos = tmp;
    });
    builder.addCase(checkActions.fulfilled, (state, { payload, meta }) => {
      if (meta.arg.offer.OfferID && Array.isArray(state.offerInfos?.Offers?.Offer)) {
        let infos = { ...state.offerInfos };

        infos.Offers.Offer = infos.Offers.Offer.map((o) => (o.OfferID == meta.arg.offer.OfferID ? { ...o, promo: payload.data } : o));

        state.offerInfos = infos;
      }
    });

    builder.addCase(checkActionsRecommended.fulfilled, (state, { payload, meta }) => {
      if (meta.arg.offer.OfferID && Array.isArray(state.recommendedInfos?.Offers?.Offer)) {
        let infos = { ...state.recommendedInfos };

        infos.Offers.Offer = infos.Offers.Offer.map((o) => (o.OfferID == meta.arg.offer.OfferID ? { ...o, promo: payload.data } : o));

        state.recommendedInfos = infos;
      }
    });

    builder.addCase(checkActionsDesired.fulfilled, (state, { payload, meta }) => {
      if (meta.arg.offer.OfferID && Array.isArray(state.desiredInfos?.Offers?.Offer)) {
        let infos = { ...state.desiredInfos };

        infos.Offers.Offer = infos.Offers.Offer.map((o) => (o.OfferID == meta.arg.offer.OfferID ? { ...o, promo: payload.data } : o));

        state.desiredInfos = infos;
      }
    });

    builder.addCase(searchOffers.pending, () => {
      //state.offerInfos = {};
    });

    builder.addCase(searchOffers.fulfilled, (state, { payload, meta }) => {
      if (payload.RS_Metadata.TransactionID != state.offerqueryid) return;
      state.searchParams = payload.search;
      state.searchParams.searched = true;
      state.offersSearched = true;
      if (meta.arg.offset === 0) {
        state.queryorder = [];
        if (payload.Offers.OfferCount > 0) {
          state.offerInfos = payload;
        } else {
          state.offerInfos = {};
        }
      } else {
        if (payload.Offers.OfferCount > 0) {
          let infos = { ...state.offerInfos };

          infos.Offers.OfferCount += payload.Offers.OfferCount;
          infos.Offers.MoreOffersAvailable = payload.Offers.MoreOffersAvailable;
          infos.Offers.Offer = [...infos.Offers.Offer, ...payload.Offers.Offer];
          if (infos.StationDictionary?.Station) infos.StationDictionary.Station = [...infos.StationDictionary.Station, ...payload.StationDictionary.Station];

          infos.HotelDictionary.Hotel = [...infos.HotelDictionary.Hotel, ...payload.HotelDictionary.Hotel];
          infos.GeoDictionary.Cities.City = [...infos.GeoDictionary.Cities.City, ...payload.GeoDictionary.Cities.City];

          infos.GeoDictionary.Continents.Continent = [...infos.GeoDictionary.Continents.Continent, ...payload.GeoDictionary.Continents.Continent];
          infos.GeoDictionary.Countries.Country = [...infos.GeoDictionary.Countries.Country, ...payload.GeoDictionary.Countries.Country];
          infos.GeoDictionary.Provinces.Province = [...infos.GeoDictionary.Provinces.Province, ...payload.GeoDictionary.Provinces.Province];

          infos.GeoDictionary.RegionGroups.RegionGroup = [...infos.GeoDictionary.RegionGroups.RegionGroup, ...payload.GeoDictionary.RegionGroups.RegionGroup];
          infos.GeoDictionary.Regions.Region = [...infos.GeoDictionary.Regions.Region, ...payload.GeoDictionary.Regions.Region];

          state.offerInfos = infos;
        }
      }
      let infos = { ...state.offerInfos };
      let roomtypes = [...state.specialRoomTypes];
      let spaArray = [];
      if (!payload.Offers.MoreOffersAvailable && infos?.Offers) {
        //console.log(infos.Offers.Offer);
        for (let i = 0; i < infos.Offers.Offer.length; i++) {
          if (Array.isArray(infos.Offers.Offer[i].MarketingActions) && infos.Offers.Offer[i].MarketingActions.length > 0 && infos.Offers.Offer[i].MarketingActions[0].roommouseovers) {
            let roomnames = infos.Offers.Offer[i].MarketingActions[0].roommouseovers;
            for (let j = 0; j < roomtypes.length; j++) {
              if (roomnames.indexOf(roomtypes[j]) > -1) {
                let spa = spaArray.find((e) => {
                  return e.value === roomtypes[j];
                });
                if (spa) {
                  spa.amount = spa.amount + 1;
                } else {
                  spaArray.push({ value: roomtypes[j], amount: 1 });
                }
              }
            }
          }
        }
      }
      state.specialAmount = spaArray;
    });
    builder.addCase(searchOffers.rejected, (state) => {
      state.offerInfos = {};
    });

    builder.addCase(searchDesiredHotels.pending, (state) => {
      state.desiredInfos = {};
    });

    builder.addCase(searchDesiredHotels.fulfilled, (state, { payload, meta }) => {
      if (payload.RS_Metadata.TransactionID != state.offerqueryid) return;
      state.searchParams = payload.search;
      state.searchParams.searched = true;
      state.offersSearched = true;
      if (meta.arg.offset === 0) {
        state.queryorder = [];
        if (payload.Offers.OfferCount > 0) {
          state.desiredInfos = payload;
        } else {
          state.desiredInfos = {};
        }
      } else {
        if (payload.Offers.OfferCount > 0) {
          let infos = { ...state.desiredInfos };

          infos.Offers.OfferCount += payload.Offers.OfferCount;
          infos.Offers.MoreOffersAvailable = payload.Offers.MoreOffersAvailable;
          infos.Offers.Offer = [...infos.Offers.Offer, ...payload.Offers.Offer];
          if (infos.StationDictionary?.Station) infos.StationDictionary.Station = [...infos.StationDictionary.Station, ...payload.StationDictionary.Station];

          infos.HotelDictionary.Hotel = [...infos.HotelDictionary.Hotel, ...payload.HotelDictionary.Hotel];
          infos.GeoDictionary.Cities.City = [...infos.GeoDictionary.Cities.City, ...payload.GeoDictionary.Cities.City];

          infos.GeoDictionary.Continents.Continent = [...infos.GeoDictionary.Continents.Continent, ...payload.GeoDictionary.Continents.Continent];
          infos.GeoDictionary.Countries.Country = [...infos.GeoDictionary.Countries.Country, ...payload.GeoDictionary.Countries.Country];
          infos.GeoDictionary.Provinces.Province = [...infos.GeoDictionary.Provinces.Province, ...payload.GeoDictionary.Provinces.Province];

          infos.GeoDictionary.RegionGroups.RegionGroup = [...infos.GeoDictionary.RegionGroups.RegionGroup, ...payload.GeoDictionary.RegionGroups.RegionGroup];
          infos.GeoDictionary.Regions.Region = [...infos.GeoDictionary.Regions.Region, ...payload.GeoDictionary.Regions.Region];

          state.desiredInfos = infos;
        }
      }
      let infos = { ...state.desiredInfos };
      let roomtypes = [...state.specialRoomTypes];
      let spaArray = [];
      if (!payload.Offers.MoreOffersAvailable && infos?.Offers) {
        //console.log(infos.Offers.Offer);
        for (let i = 0; i < infos.Offers.Offer.length; i++) {
          if (Array.isArray(infos.Offers.Offer[i].MarketingActions) && infos.Offers.Offer[i].MarketingActions.length > 0 && infos.Offers.Offer[i].MarketingActions[0].roommouseovers) {
            let roomnames = infos.Offers.Offer[i].MarketingActions[0].roommouseovers;
            for (let j = 0; j < roomtypes.length; j++) {
              if (roomnames.indexOf(roomtypes[j]) > -1) {
                let spa = spaArray.find((e) => {
                  return e.value === roomtypes[j];
                });
                if (spa) {
                  spa.amount = spa.amount + 1;
                } else {
                  spaArray.push({ value: roomtypes[j], amount: 1 });
                }
              }
            }
          }
        }
      }
      state.specialAmount = spaArray;
    });
    builder.addCase(searchDesiredHotels.rejected, (state) => {
      state.desiredInfos = {};
    });
    builder.addCase(searchRecommendedHotels.pending, (state) => {
      state.desiredInfos = {};
    });

    builder.addCase(searchRecommendedHotels.fulfilled, (state, { payload, meta }) => {
      if (payload.RS_Metadata.TransactionID != state.offerqueryid) return;
      state.searchParams = payload.search;
      state.searchParams.searched = true;
      state.offersSearched = true;
      if (meta.arg.offset === 0) {
        state.queryorder = [];
        if (payload.Offers.OfferCount > 0) {
          state.recommendedInfos = payload;
        } else {
          state.recommendedInfos = {};
        }
      } else {
        if (payload.Offers.OfferCount > 0) {
          let infos = { ...state.recommendedInfos };

          infos.Offers.OfferCount += payload.Offers.OfferCount;
          infos.Offers.MoreOffersAvailable = payload.Offers.MoreOffersAvailable;
          infos.Offers.Offer = [...infos.Offers.Offer, ...payload.Offers.Offer];
          if (infos.StationDictionary?.Station) infos.StationDictionary.Station = [...infos.StationDictionary.Station, ...payload.StationDictionary.Station];

          infos.HotelDictionary.Hotel = [...infos.HotelDictionary.Hotel, ...payload.HotelDictionary.Hotel];
          infos.GeoDictionary.Cities.City = [...infos.GeoDictionary.Cities.City, ...payload.GeoDictionary.Cities.City];

          infos.GeoDictionary.Continents.Continent = [...infos.GeoDictionary.Continents.Continent, ...payload.GeoDictionary.Continents.Continent];
          infos.GeoDictionary.Countries.Country = [...infos.GeoDictionary.Countries.Country, ...payload.GeoDictionary.Countries.Country];
          infos.GeoDictionary.Provinces.Province = [...infos.GeoDictionary.Provinces.Province, ...payload.GeoDictionary.Provinces.Province];

          infos.GeoDictionary.RegionGroups.RegionGroup = [...infos.GeoDictionary.RegionGroups.RegionGroup, ...payload.GeoDictionary.RegionGroups.RegionGroup];
          infos.GeoDictionary.Regions.Region = [...infos.GeoDictionary.Regions.Region, ...payload.GeoDictionary.Regions.Region];

          state.recommendedInfos = infos;
        }
      }
      let infos = { ...state.recommendedInfos };
      let roomtypes = [...state.specialRoomTypes];
      let spaArray = [];
      if (!payload.Offers.MoreOffersAvailable && infos?.Offers) {
        //console.log(infos.Offers.Offer);
        for (let i = 0; i < infos.Offers.Offer.length; i++) {
          if (Array.isArray(infos.Offers.Offer[i].MarketingActions) && infos.Offers.Offer[i].MarketingActions.length > 0 && infos.Offers.Offer[i].MarketingActions[0].roommouseovers) {
            let roomnames = infos.Offers.Offer[i].MarketingActions[0].roommouseovers;
            for (let j = 0; j < roomtypes.length; j++) {
              if (roomnames.indexOf(roomtypes[j]) > -1) {
                let spa = spaArray.find((e) => {
                  return e.value === roomtypes[j];
                });
                if (spa) {
                  spa.amount = spa.amount + 1;
                } else {
                  spaArray.push({ value: roomtypes[j], amount: 1 });
                }
              }
            }
          }
        }
      }
      state.specialAmount = spaArray;
    });
    builder.addCase(searchRecommendedHotels.rejected, (state) => {
      state.recommendedInfos = {};
    });
  },
});
export const {
  setOfferInfos,
  setOfferPage,
  setOfferSort,
  setMarked,
  setMemo,
  addToMemo,
  removeFromMemo,
  setSelectedOfferId,
  setSpecialRoomTypes,
  setOffersSearched,
  setOfferqueryid,
  setBanners,
  setAdditionals,
  setRegioninfos,
  setRecommendedHotels,
  setRecommendedInfos,
  setDesiredInfos,
  setAlternativeRegionName,
} = offersSlice.actions;

export default offersSlice.reducer;
